import styled, { keyframes } from "styled-components/macro"
import { ReactComponent as DownArrow } from "../../images/navdownarrow-10px-12px.svg"
import React from 'react';
import * as colors from "./ColorScheme";

const breatheAnimation = keyframes`
 0% { transform: scale(1) }
 25% { transform: scale(1.15) }
 50% { transform: scale(1) }
 75% { transform: scale(0.95) }
 100% { transform: scale(1)}
`

const LARGE_VIEW_BREAKPOINT = "1794px";
const MEDIUM_VIEW_BREAKPOINT = '1200px';
const SMALL_VIEW_BREAKPOINT = '880px';

const centeredLinkInButton = `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: inherit;
    text-decoration-line: none;
`;

type ToolTipWrapperProps = {
    cursorCoords: {x: number, y: number};
}

export const ControlRow = styled.div`
    z-index : 1000;
    display:flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    min-width: 560px;
    flex-wrap: wrap;
    column-gap: 8px; // set the gap between control sections
    row-gap: 20px; // set the gap between rows if control sections wrap
    @media(max-width: ${LARGE_VIEW_BREAKPOINT}) {
        justify-content: center;
        column-gap: 18px; // ensure that the controls sections will wrap once the separator disappears 
    }
        @media(max-width: ${SMALL_VIEW_BREAKPOINT}) {
        justify-content: flex-start;
        min-width: 600px;
    }
`;

export const ToolTipWrapper = styled.div<ToolTipWrapperProps>`
    padding: 8px;
    border: 1px solid #979a9e;
    box-shadow: 2px 2px 4px #47484a;
    border-radius: 5px;
    width: 300px;
    z-index: 1;
    background-color: white;
    font-size: 14px;
    display: inline-block;
    color: #47484a;
    position: absolute;
    bottom: -90px;
    left: 80px;
`;

export const ToolTipText = styled.p`
    margin: 0;`

export const SubmitButton = styled.div<{disabled: boolean}>`
    width: 80px;
    height: 40px;
    background: ${props => props.disabled ? colors.ezio_grey_green : "rgba(3, 94, 91, 0.8)"};
    border-radius: 5px;
    color: white;
    font-family: "Arimo", "Roboto";
    font-style: normal;
    cursor: ${props => props.disabled ? 'default' : 'pointer'};
    font-size: 16px;
    align-items: center;
    justify-content: center;
    display:flex;
    transition: 0.1s filter linear;
    &:hover {
        filter: ${props => {
            if(!props.disabled) return 'drop-shadow(4px 2px 10px rgba(74, 74, 74, 0.45));'      
    }}
    a{
        ${centeredLinkInButton}
    }
`

export const StyledCheckbox = styled.input`
    height: 15px;
    width: 15px;
    margin-left:5px;
    cursor: pointer;
`

export const CheckboxLabel = styled.span`
    color: #4A4A4A;
    font-size: 16px;
    font-family: "Arimo", "Roboto";
`

export const ControlSection = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;
    @media(max-width: ${LARGE_VIEW_BREAKPOINT}) {
        gap: 16px; // space out the controls once the sections wrap
    }
    @media(max-width: ${MEDIUM_VIEW_BREAKPOINT}) {
        width: 600px;
    }
    @media(max-width: ${SMALL_VIEW_BREAKPOINT}) {
    justify-content: flex-start;
    }
`;

const UpdateButton = styled.img`
    cursor: pointer;
background-color: white;
border: none;
height: 27px;
width: 25px;
margin: 4px;
background-repeat: no-repeat;
background-size: auto 100%;
`

export const UpdateButtonGray = styled(UpdateButton)`

`
export const UpdateButtonActive = styled(UpdateButton)`
animation-name: ${breatheAnimation};
animation-duration: 1.5s;
animation-iteration-count: infinite;

`

export const ControlItem = styled.div`
position: relative;
width: min-content;
`

export const ControlItemSwitch = styled.div`
position: relative;
width: auto;
border: 2px;
`

export const DropdownContainer = styled.div`
position: absolute;
top:100%;
left: 0;
height: 10rem;
overflow-y: auto;
overflow-x: hidden;
`

//Styles shared by dropdown components

export const OptionWrapper = styled.div`
display: flex;
font-size: 16px;`


export const VerticalRule = styled.div`
    width: 2px;
    height: 40px;
    background-color: ${colors.ezio_light_grey};

    @media(max-width: ${LARGE_VIEW_BREAKPOINT}) {
        display: none;
    }
`

export const BulletPoint = styled.div`
display: flex;
justify-content: center;
align-items: center;
height: 18px;
width: 16px;
color: ${colors.ezio_dark_green};`

export const ChargeTypeWrapper = styled.div`
display: inline-block;
cursor: pointer;
`

const MenuButton = styled.div`
cursor: pointer;
font-family: Arimo;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 19px;
color: ${colors.ezio_dark_grey};
height: 40px;
background: #FFFFFF;
border: 2px solid ${colors.ezio_light_grey};
box-sizing: border-box;
border-radius: 5px;
white-space: nowrap;
overflow: hidden;`

export const MenuText = styled.div`
margin-left: 16px;
display: inline-block;
justify-content: flex-start;
align-items: center;
overflow: hidden;
text-overflow: ellipsis;
height: 100%;
line-height: 36px;
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;

`

export const GroupsMenuText = styled(MenuText)`
width: 120px;
`

export const CategoryMenuText = styled(MenuText)`
width: 180px;
`

export const LocationsMenuText = styled(MenuText)`
width: 160px;`

export const ElectrificationMenuText = styled(MenuText)`
width: 160px;`



export const ClassesMenuText = styled(MenuText)`
width: 100px;`


export const SelectedLabel = styled.div`
height: 100%;`


export const CategoryMenuButton = styled(MenuButton)`
width: 220px;
`

export const GroupsMenuButton = styled(MenuButton)`
width: 160px;
`

export const LocationsMenuButton = styled(MenuButton)`
width: 200px;
`

export const ElectrificationMenuButton = styled(MenuButton)`
width: 185px;
`


export const ClassesMenuButton = styled(MenuButton)`
width: 125px;
`

export const LocationTypeMenuButton = styled(MenuButton)`
width: 275px;
`

export const LocationTypeMenuText = styled(MenuText)`
width: 255px;`

export const DownArrowWrapper = styled.div`
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
bottom: 1px;
right: 10px;
position: absolute;
height: 100%;
width: 14px;

`

//Not exactly a styled component, but exists purely as style and goes in multiple places so fits here
export const CustomDownChevron = () => <DownArrowWrapper>
    <DownArrow />
</DownArrowWrapper>

//This is how react-select wants you to style it
export const SelectStyles = {
    valueContainer: (base: any) => ({
        ...base,
        cursor: "text",
        paddingLeft: "13px",
        margin: "5px",
        height: "27px",
        border: "1px solid #4A4A4A",
        borderRadius: "5px",
        fontSize: "12px",
        lineHeight: "14px"
    }),
    container: (base: any) => ({
        ...base,
        cursor: "pointer",
        width: "15rem",
        fontFamily: "Arimo",
        fontSize: "20px",

    }),

    control: (base: any, { isFocused }: any) => ({
        ...base,
        fontFamily: "Arimo",
        border: isFocused ? 0 : 0,
        // This line disable the blue border
        boxShadow: isFocused ? 0 : 0,
        '&:hover': {
            border: isFocused ? 0 : 0
        },
        minWidth: "240",
        margin: "8",
    }),
    option: (base: any, { isFocused, isSelected, isDisabled }: { isFocused: boolean, isSelected: boolean, isDisabled: boolean }) => ({
        ...base,
        cursor: "pointer",
        fontFamily: "Arimo",
        fontSize: "16px",
        color: isDisabled ? colors.ezio_medium_grey : "inherit",
        padding: "8px 0",
        ":hover": {
            backgroundColor: isDisabled ? null : "rgba(3, 94, 91, 0.2)",
            cursor: isDisabled ? "default": "pointer"
        },
        backgroundColor: isSelected
            ? "rgba(3, 94, 91, 0.2)"
            : null,
        ":active": {
            backgroundColor: null
        }
    }),
    noOptionsMessage: (base: any) => ({
        ...base,
        fontFamily: "Arimo",
        fontSize: "16px",

    }),

    menuList: (base: any) => ({
        ...base,

        maxHeight: "300px",
        overflow: "overlay",

        "::-webkit-scrollbar": {
            width: "5px"
        },
        "::-webkit-scrollbar-track": {
            background: "transparent"
        },
        "::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "10825432px"
        },
        "::-webkit-scrollbar-thumb:hover": {
            background: "#555"
        }
    }),
    menu: () => ({

        marginTop: "0",
    }),
    placeholder: (base: any) => ({
        ...base,
        verticalAlign: "middle"
    }
    )



}
